import { GridRenderCellParams, GridColDef } from '@mui/x-data-grid-premium'
import { Button, Chip, Status, StatusState, StatusVariant, TableCell } from '@ketch-com/deck'
import { Typography } from '@mui/material'
import { formatDateTimeFromUnix } from 'utils/helpers/dateTime'
import { PurposeDTO } from 'interfaces/purposes/purpose'
import { FirstNameLastNameRenderer } from 'components/renderers/FirstNameLastNameRenderer'

export const cookieVersionsTabGridColumns = (
  currentVersion: number,
  removeQueryParam: (key: 'version') => void,
  setQueryParam: (key: 'version', value: string | number | boolean | string[] | number[]) => void,
): GridColDef<PurposeDTO>[] => [
  {
    align: 'left',
    headerAlign: 'left',
    field: 'status',
    headerName: 'Status',
    sortable: false,
    flex: 1,
    maxWidth: 150,
    renderCell: ({ row }: GridRenderCellParams<PurposeDTO>) => {
      return (
        <TableCell>
          {!!row.latest && (
            <Status icon="Dot" label="Latest" status={StatusState.success} variant={StatusVariant.ghost} />
          )}
        </TableCell>
      )
    },
  },
  {
    align: 'left',
    headerAlign: 'left',
    field: 'version',
    headerName: 'Version',
    sortable: false,
    flex: 1,

    renderCell: ({ row }: GridRenderCellParams<PurposeDTO>) => {
      return (
        <TableCell>
          <Chip size="small" label={`v${row.version}`} />
        </TableCell>
      )
    },
  },

  {
    align: 'left',
    headerAlign: 'left',
    field: 'name',
    headerName: 'Name',
    sortable: false,
    flex: 1,

    renderCell: ({ row }: GridRenderCellParams<PurposeDTO>) => {
      return <TableCell title={row.name} subTitle={row.code}></TableCell>
    },
  },
  {
    align: 'left',
    field: 'updatedAt',
    headerAlign: 'left',
    flex: 1,
    headerName: 'Created',

    sortable: false,
    renderCell: ({ row }: GridRenderCellParams<PurposeDTO>) => {
      if (row.version) {
        return <TableCell title={formatDateTimeFromUnix(row.version)}></TableCell>
      }
      return (
        <TableCell>
          <Typography color={'lightGrey.main'} variant="body">
            None
          </Typography>
        </TableCell>
      )
    },
  },
  {
    field: 'createdBy',
    width: 200,
    headerName: 'Created By',
    sortable: false,
    renderCell: ({ row: { audit } }: GridRenderCellParams<PurposeDTO>) => {
      return (
        <TableCell>
          <FirstNameLastNameRenderer firstName={audit?.updatedBy?.firstName} lastName={audit?.updatedBy?.lastName} />
        </TableCell>
      )
    },
  },
  {
    align: 'left',
    field: 'actions',
    headerAlign: 'left',
    headerName: '',
    sortable: false,
    maxWidth: 100,
    renderCell: ({ row }: GridRenderCellParams<PurposeDTO>) => {
      return (
        <TableCell>
          <Button
            color="tertiary"
            disabled={row.version === currentVersion}
            onClick={() => {
              if (row.latest) {
                removeQueryParam('version')
              } else {
                setQueryParam('version', row.version!)
              }
            }}
          >
            View
          </Button>
        </TableCell>
      )
    },
  },
]
